export const getPhoneAvatarImage = (returnImagesWithGrayBorder?: boolean): string => {
  return `https://doris-media-production.s3.sa-east-1.amazonaws.com/mix-static-assets/sb-${
    returnImagesWithGrayBorder ? 'gray-' : ''
  }phone-avatar.png`
}

export const ONBOARDING_STORAGE_KEY = '@doris_onboarding_viewed'

export const isOnboardingViewed = (): boolean => {
  return !!localStorage.getItem(ONBOARDING_STORAGE_KEY)
}

export const setOnboardingAsViewed = (): void => {
  localStorage.setItem(ONBOARDING_STORAGE_KEY, '1')
}

export const clearOnboardingInteraction = (): void => {
  localStorage.removeItem(ONBOARDING_STORAGE_KEY)
}
